import PropTypes from 'prop-types';
import React from 'react';
import DatePicker from 'react-datepicker';

import BaseInput from 'components/atomic/controls/BaseInput';

const YearInput = ({ name, placeholder, disabled, value, onBlur, onChange, ...restProps }) => {
  const handleChange = (year) => {
    onChange && onChange({ target: { name, value: year } });
  };

  return (
    <DatePicker
      closeOnScroll
      showYearPicker
      popperPlacement="top"
      disabled={disabled}
      placeholderText={placeholder}
      dateFormat="yyyy"
      selected={value}
      onChange={handleChange}
      onBlur={onBlur}
      customInput={<BaseInput name={name} {...restProps} />}
    />
  );
};

YearInput.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default YearInput;
